<ng-progress color="#4ba5ed" [spinner]="false"></ng-progress>
<router-outlet></router-outlet>
<flash-messages></flash-messages>
